import { Verification } from './../settings/verification';
import { Http, RequestOptions, Headers } from '@angular/http';
import { AuthService, User } from './../user/auth.service';
import { Subject } from 'rxjs/Subject';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { RegistryService } from '../registry/registry.service';
import { ConfigurationService } from '../shared/configuration.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { Registry } from '../registry/registry';
import { Settings } from '../settings/settings';
import { environment } from '../../environments/environment';
import { Gift } from '../gift/gift';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { take, filter } from 'rxjs/operators';

@Component({
  selector: 'app-account-payment',
  templateUrl: './account-payment.component.html',
  styleUrls: ['./account-payment.component.scss']
})
export class AccountPaymentComponent implements OnInit, OnDestroy {
  isConnected: boolean;
  registry: Registry;
  isLoaded = false;
  settingsProcessing = false;
  processing = false;
  stripeProcessing = false;
  conversionCompleted = false;
  isVerified: boolean;
  stripeAccountId: string;
  baseUrl: string;
  pricingTextLight: string;
  isOld = false;
  dupeStripeAccount = false;
  order_id: string = null;
  invalidRegistryName = false
  urlConfirmed = false;
  total: string = null;
  coppied = false;
  country: string;
  currency: string;
  currencyLabel: string;
  stripeClientId: string;
  visibilityStatus: string;
  step3formChange = false;
  settings: Settings;
  stripeLinksProcessing = false;
  paid = false;
  user: User;
  isChargesPendingProcessing = false;
  requiresIdBeforeChargesEnabled = false;
  firstLaunchSaving = false;
  otherStripeErrors: string[];

  stripeOauthUrl = null;
  gifts: Gift[];
  stripeSuccessSeen = true;
  linkStripeError = false;
  registryNameChanges$ = new Subject<string>();


  numOfCustomPaymentMethods = 0;
  updatedLinks = true;
  token: string;
  fromStripe = false;
  revertRegistry: Registry;
  defaultGiftPriceChanged = false;
  private ngUnsubscribe: Subject<void> = new Subject();
  passwordSaved: boolean = undefined;
  // recAmountSaved = false;
  showPopup = false;
  verification: Verification;
  step = 1;
  otherStripeFieldNeeded = false;
  requiresMoreInfo: boolean = false;
  conversionAlreadySent: boolean = false;
  registryNotAvailableError: boolean;
  checkingRegistryName = false;
  mustAddPaymentMethods: boolean;
  feeSelected: boolean = false;
  private conversionProcessed = false;
  private queryParams: any;

  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _configuration: ConfigurationService,
    private _analyticsService: AnalyticsService,
    private _authService: AuthService,
    private _http: Http,
    private _registryService: RegistryService,
    private route: ActivatedRoute,
    private _router: Router
  ) {
    this.showPopup = false;
    this._router.events.filter(event => event instanceof NavigationEnd).subscribe((event: any) => {
      ;
      if (event && event.url && ((event.url.includes('/registry/publish/step-1'))
        || (event.url.includes('/registry/publish/step-2'))
        || (event.url.includes('/registry/publish/step-3'))
        || (event.url.includes('/registry/publish'))
      )

      ) {



        this.revertRegistry = new Registry();
        this.step3formChange = false;
        this.firstLaunchSaving = false;
        this.settingsProcessing = false;
        this.stripeProcessing = false;

        if (!this.registry && this._registryFirebaseService && this._registryFirebaseService.registry) {
          this.registry = this._registryFirebaseService.registry;

          this.setVisibilityStatus();
          Object.assign(this.revertRegistry, this.registry);

        }


        // ;
        if (event.url === '/registry/publish') {



          if (this.registry && this.registry.paid !== undefined
            && (this.settings && (!this.settings.chargesEnabled || !this.settings.payoutsEnabled)
              || !this.settings || !this.settings.stripeAccountId)) {
            this._router.navigateByUrl('/registry/publish/step-2', { replaceUrl: true });

          } else if (this.registry && this.registry.paid === undefined && (!this.settings || !this.settings.capabilities)) {
            this._router.navigateByUrl('/registry/publish/step-2', { replaceUrl: true });

          } else if (this.registry && (this.registry.paid === undefined)) {
            this._router.navigateByUrl('/registry/publish/step-3', { replaceUrl: true });

          } else if (this.registry && (this.settings.chargesEnabled && this.settings.payoutsEnabled)) {
            this._router.navigateByUrl('/registry/publish/step-3', { replaceUrl: true });

          } else {
            this.loadPopup();
          }


        }

        if (event.url.includes('/registry/publish/step-1')) {
          this.step = 1;
          this.loadPopup();
        }

        if (event.url.includes('/registry/publish/step-2?cancelFromStripe=true')) {
          this.step = 2;
          this.loadPopup();
        }
        if (event.url.includes('/registry/publish/step-2?paid=true')) {

          this.step = 2;
          this.loadPopup();
        }
        if (event.url.includes('/registry/publish/step-2')) {
          this.step = 2;
          this.loadPopup();
        }

        if (event.url.includes('publish?utm_campaign=intercom_trialexpired_2')) {
          this._router.navigateByUrl('/visibility', { replaceUrl: true });
        }




        if (event.url.includes('/registry/publish/step-3')) {

          this.step = 3;
          this.loadPopup();
          // return this._router.navigateByUrl('/visibility', { replaceUrl: true});


          // const stripeSuccessSeen = localStorage.getItem('seen_stripe_success_msg');

          // if (!stripeSuccessSeen){
          //   this.stripeSuccessSeen = false;
          //   localStorage.setItem('seen_stripe_success_msg', 'true');
          // } else {
          //   this.stripeSuccessSeen = true;
          // }
          // this.loadPopup();
        }

      } else {
        this.showPopup = false;
      }

    });

    this._authService.authToken().subscribe(token => {
      this.token = token;
    });

    document.title = 'Account | Hitchd';
    this._authService.user.takeUntil(this.ngUnsubscribe).subscribe(user => {
      this.user = user;
      this._registryFirebaseService.initGiftsForUser(user);
    });
    this.baseUrl = this._configuration.baseUrl;
    this.stripeClientId = this._configuration.stripeClientId;

    //  this.loadForm();


    this.route.queryParams
      .pipe(take(1))
      .subscribe(params => {
        this.queryParams = params;
        this.handleStripeParams(params);
      });

    // Wait for user to be authenticated
    this._authService.user
      .pipe(
        filter(user => !!user),
        take(1)
      )
      .subscribe(user => {
        if (this.queryParams && this.queryParams.currency && this.queryParams.value && !this.conversionProcessed) {
          this.processConversion(user.userId);
        }
      });

  }

  containsOnlyAlphanumeric(str: string): boolean {
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;

    return alphanumericRegex.test(str);
  }


  setVisibilityStatus() {

    if (!this.registry.isLive) {
      this.visibilityStatus = 'private';
    } else if (this.registry.password) {
      this.visibilityStatus = 'password';
    } else if (this.registry.isLive) {
      this.visibilityStatus = 'public';
    }
  }

  setRegistryVisibilityStatus() {
    this.registry.hasPassword = false;
    if (this.visibilityStatus === 'private') {
      this.registry.isLive = false;
    } else if (this.visibilityStatus === 'password') {
      this.registry.isLive = true;
      this.registry.hasPassword = true;
    } else if (this.visibilityStatus === 'public') {
      this.registry.isLive = true;
    }
  }

  loadPopup() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

    this.loadForm();

    this.showPopup = true;

    //const paymentMethodsModalDiv = document.getElementById('account-payments-modal') ;
    //(document.querySelector('app-account-payment-payment') as any) .style.display = 'none';

  }



  // checkDomainName(control: AbstractControl) {
  //   if (this.hitchdForm && control && control.value) {
  //     this.registryName = control.value.toLowerCase();
  //     if (
  //       this.registryName.toLowerCase() !==
  //       this.registry.registryName.toLowerCase()
  //     ) {
  //       //
  //       this._registryFirebaseService
  //         .registryByName(control.value)
  //         .take(1)
  //         .subscribe(registry => {
  //           //
  //           if (registry) {
  //             this.hitchdForm.controls['registryName'].setErrors({
  //               registryNotavailable: true
  //             });
  //           }
  //         });
  //     }
  //   }
  // }


  ngOnInit() {
    this._registryService.setScrollY(1);
    this.gifts = this.route.snapshot.data.gifts;
    this.registry = this.route.snapshot.data.registry;
    if (this.registry && !this.registry.hasPassword) {
      this.registry.hasPassword = false;
    }


    // Subscribe to the changes with a debounce of 1 second
    this.registryNameChanges$.pipe(debounceTime(1000)).subscribe(() => {
      // Perform the check here

      this.invalidRegistryName = false;
      if (!this.containsOnlyAlphanumeric(this.registry.registryName)) {
        this.invalidRegistryName = true;
      }

      this.registryNotAvailableError = false;
      //
      this.checkingRegistryName = false;
      this._registryFirebaseService
        .registryByName(this.registry.registryName.toLowerCase())
        .take(1)
        .subscribe(registry => {
          //
          if (registry && registry.userId !== this.registry.userId) {
            this.registryNotAvailableError = true;
          }
        });

      //   }

    });


  }

  updateRegistryName() {
    this.checkingRegistryName = true;
    this.urlConfirmed = false;

    this.registry.registryName = this.registry.registryName.toLowerCase();
    this.registryNameChanges$.next(this.registry.registryName);
  }

  dataChanged(newObj) {
    // here comes the object as parameter
  }

  confirmUrl() {
    this.urlConfirmed = true;
    this.registry.registryName = this.registry.registryName.toLowerCase();

    this._registryFirebaseService.updateReg(this.registry).then(() => {

    });
  }

  revert() {
    Object.assign(this.registry, this.revertRegistry);
    this._router.navigate(['/registry']);
  }
  // getNavigatorLanguage = () => (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';

  updateCurrency() {
    switch (this.currency) {
      case 'AUD': {
        this.currencyLabel = 'AUD $';
        break;
      }
      case 'MXN': {
        this.currencyLabel = 'MXN $';
        break;
      }
      case 'USD': {
        this.currencyLabel = 'USD $';
        break;
      }
      case 'GBP': {
        this.currencyLabel = 'GBP £';
        break;
      }
      case 'NZD': {
        this.currencyLabel = 'NZD $';
        break;
      }

      case 'DKK': {
        this.currencyLabel = 'Kr';
        break;
      }
      case 'JPY': {
        this.currencyLabel = 'JPY ¥';
        break;
      }
      case 'EUR': {
        this.currencyLabel = 'EUR €';
        break;
      }
      case 'SGD': {
        this.currencyLabel = 'SGD $';
        break;
      }
      case 'HKD': {
        this.currencyLabel = 'HKD $';
        break;
      }
      case 'CAD': {
        this.currencyLabel = 'CAD $';
        break;
      }
      case 'NOK': {
        this.currencyLabel = 'Kr';
        break;
      }
      case 'SEK': {
        this.currencyLabel = 'Kr';
        break;
      }
    }
    this.registry.currency = this.currency;
    // this.setCurrency();
    this.setPricingFaqLight();

  }



  resetPasswordSaved() {
    this.passwordSaved = false;
  }

  setCurrency() {

    this.registry.country = this.country;
    switch (this.country) {
      case 'AU': {
        this.currency = 'AUD';
        break;
      }
      case 'MX': {
        this.currency = 'MXN';
        break;
      }
      case 'US': {
        this.currency = 'USD';
        break;
      }
      case 'GB': {
        this.currency = 'GBP';
        break;
      }
      case 'NZ': {
        this.currency = 'NZD';
        break;
      }
      case 'MX': {
        this.currency = 'MXN';
        break;
      }

      case 'JP': {
        this.currency = 'JPY';
        break;
      }

      case 'CA': {
        this.currency = 'CAD';
        break;
      }
      case 'AT': {
        this.currency = 'EUR';
        break;
      }
      case 'BE': {
        this.currency = 'EUR';
        break;
      }
      case 'EE': {
        this.currency = 'EUR';
        break;
      }
      case 'FI': {
        this.currency = 'EUR';
        break;
      }
      case 'FR': {
        this.currency = 'EUR';
        break;
      }
      case 'DE': {
        this.currency = 'EUR';
        break;
      }
      case 'DK': {
        this.currency = 'DKK';
        break;
      }
      case 'GR': {
        this.currency = 'EUR';
        break;
      }
      case 'IE': {
        this.currency = 'EUR';
        break;
      }
      case 'IT': {
        this.currency = 'EUR';
        break;
      }
      case 'LV': {
        this.currency = 'EUR';
        break;
      }
      case 'LT': {
        this.currency = 'EUR';
        break;
      }
      case 'LU': {
        this.currency = 'EUR';
        break;
      }
      case 'NL': {
        this.currency = 'EUR';
        break;
      }
      case 'PT': {
        this.currency = 'EUR';
        break;
      }
      case 'SK': {
        this.currency = 'EUR';
        break;
      }
      case 'SI': {
        this.currency = 'EUR';
        break;
      }
      case 'ES': {
        this.currency = 'EUR';
        break;
      }
      case 'SG': {
        this.currency = 'SGD';
        break;
      }
      case 'SG': {
        this.currency = 'USD';
        break;
      }
      case 'HK': {
        this.currency = 'HKD';
        break;
      }
      case 'SE': {
        this.currency = 'SEK';
        break;
      }
      case 'NO': {
        this.currency = 'NOK';
        break;
      }
      case 'CH': {
        this.currency = 'CHF';
        break;
      }
    }
    this.registry.currency = this.currency;
    this.updateCurrency();
  }

  loadForm() {

    this._registryFirebaseService.currentRegistry.takeUntil(this.ngUnsubscribe).take(1).subscribe(registry => {

      if (registry) {
        this.mustAddPaymentMethods = false;
        this.registry = registry;
        this.setVisibilityStatus();

        this.currency = this.registry.currency;
        this.country = this.registry.country;
        this.registry.hasPassword = this.registry.hasPassword === true;
        this.updateCurrency();
        this.setPricingFaqLight();
        this._registryFirebaseService.getSettings().takeUntil(this.ngUnsubscribe).subscribe(settings => {
          ;
          this.settings = settings;
          this.requiresMoreInfo = false;
          if (settings && settings.verification && settings.verification.fields_needed && (settings.verification.fields_needed.includes('legal_entity.personal_id_number'))) {
            this.requiresMoreInfo = true;

          }



          if (this.step == 3 && this.registry && !this.registry.hasCustomPaymentMethods && this.settings && !this.settings.stripeAccountId) {

            this.mustAddPaymentMethods = true;
          }
          else if (this.step == 3 && this.settings && this.settings.verification && this.settings.verification.errors && this.settings.stripeAccountId && this.settings.verification.errors.length && (!settings.chargesEnabled || !settings.payoutsEnabled)) {
            this.mustAddPaymentMethods = true;
          }


          else if (this.step == 3 && this.registry && this.settings && this.settings.stripeAccountId && (!this.settings.chargesEnabled || !this.settings.payoutsEnabled)) {

            this._router.navigate(['/registry/publish/step-2']);
          } else if (this.step == 2 && this.registry && this.settings && this.settings.stripeAccountId && (this.settings.chargesEnabled && this.settings.payoutsEnabled)) {
            if (this.registry && (this.settings.chargesEnabled && this.settings.payoutsEnabled)) {
              this._router.navigateByUrl('/registry/publish/step-3', { replaceUrl: true });

            }
          }

          else {
            if (this.registry.isLive === undefined && this.settings.chargesEnabled && this.settings.payoutsEnabled) {
              this.visibilityStatus = 'public';
              this.step3formChange = true;
            }
            if (this.settings && this.settings.stripeAccountId && !this.settings.stripeSetupLink) {
              this.isOld = true;
            }

            this.isPendingChargesEnabled();
            this.requiresIdVerificationBeforeChanrgesEnabled();
            if (this.registry.paid === undefined && this.registry.isLive && !this.updatedLinks) {
              this.setupStripe(this.settings.stripeAccountId, true).then(() => {

                this.updatedLinks = true;
              });
            }


            if (this.settings
              && this.settings.stripeAccountId) {

              this._registryFirebaseService.killLoader();
              this.isLoaded = true;
              this.processStripeData();


              // });
            } else {
              this._registryFirebaseService.killLoader();
              this.isLoaded = true;
            }
          }
        });
      }
    });


  }

  requiresIdVerificationBeforeChanrgesEnabled() {


    this.requiresIdBeforeChargesEnabled = this.settings && this.settings.verification

      && this.settings.verification.fields_needed
      && (this.settings.verification.fields_needed.includes('legal_entity.verification.document')
        || this.settings.verification.fields_needed.includes('legal_entity.personal_id_number')

      )

      ;
  }
  isPendingChargesEnabled() {
    // ;
    this.isChargesPendingProcessing =
      (
        (
          this.settings.verification
          && this.settings.verification.pending_verification
          && this.settings.verification.pending_verification.includes('legal_entity.verification.document'))
        ||
        (((this.settings && this.settings.verification
          && this.settings.verification.disabled_reason
          && this.settings.verification.disabled_reason === 'fields_needed'
          && !this.settings.payoutsEnabled
          && this.settings.verification.fields_needed.length === 0))


        ));


  }

  close() {

    //(document.querySelector('app-account-payment-payment') as any) .style.display = 'block';
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this._registryService.emitHeaderPopupClosed();
    //  this.showPopup = false;
    this._router.navigate(['/registry']);


  }


  private requestOptions(): RequestOptions {
    const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers });
    return options;
  }


  processStripeData() {


    if (this.registry.hasCustomPaymentMethods) {
      return;
    }

    if (!(this.settings.chargesEnabled || this.settings.payoutsEnabled)) {
      this._router.navigateByUrl('/registry/publish/step-2', { replaceUrl: true });
    }


    if (this.step === 3 && (!this.settings.chargesEnabled || !this.settings.payoutsEnabled)) {
      this._router.navigateByUrl('/registry/publish/step-2', { replaceUrl: true });

    }
    if (this.step === 2 && (this.settings.chargesEnabled && this.settings.payoutsEnabled)) {
      this._router.navigateByUrl('/registry/publish/step-3', { replaceUrl: true });

    }
    if (this.fromStripe && !this.registry.isLive && this.settings.chargesEnabled) {
      // this.updateRegistryLiveStatus(true);
      this._router.navigateByUrl('/registry/stripe-connected', { replaceUrl: true });



    }


    if (this.settings && this.settings.verification && this.settings.verification.fields_needed) {

      let otherfields = this.settings.verification.fields_needed
        .filter(x => x !== ('legal_entity.personal_id_number') || x !== 'legal_entity.verification.document');

      if (this.settings.verification.fields_needed.includes('legal_entity.personal_id_number')
        || this.settings.verification.fields_needed.includes('legal_entity.verification.document')

        || this.settings.verification.pending_verification.includes('legal_entity.verification.document')
      ) {
        otherfields = [];
      }

      if (otherfields.length > 0) {



        this.otherStripeFieldNeeded = true;

      }

    }


    this._analyticsService.update(
      {
        stripeConnected: true,
        stripePayoutsEnabled: this.settings.payoutsEnabled,
        stripeAccountId: this.settings.stripeAccountId,
        //  registryUrl: 'https://www.hitchd.com/' + this.registry.registryName
      }
    );
  }
  setFeeGuestPay() {

    this.settings.feeOption = 3;
    this._registryFirebaseService.saveSettings(this.settings);

  }
  setFeeToAbsorb() {
    this.settings.feeOption = 1;
    this._registryFirebaseService.saveSettings(this.settings);
  }

  unlinkStripe() {
    let currentToken = null;
    this.settingsProcessing = true;
    this._authService.authToken().take(1).subscribe(token => {
      currentToken = token;


      return this._http
        .post(environment.firebase.clouldFunctionHost + '/unLinkStripeAccount', {
          token: currentToken,

        })
        .toPromise()
        .then((response: any) => {

          this.settingsProcessing = false;
          this._router.navigate(['registry', 'add-payment-methods'])
        })
        .catch((e: any) => {
          this.settingsProcessing = false;

          throw e;


        });


    });
  }

  saveAndRedirectToPayment() {
    this.processing = true;
    if (this.feeSelected === false && this.registry && this.registry.paid) {
      this.feeSelected = true;
      return;
    }
    this._registryFirebaseService.saveRegistry(this.registry).then(() => {
      this._router.navigate(['/registry/payment'], { queryParams: { fromStripe: 'true' } });
      this.processing = false;
    });
  }

  setPricingFaqLight() {

    this.pricingTextLight = '';
    switch (this.country) {
      case 'AU': {
        this.pricingTextLight =
          '1.7% + $0.30 (+1.7% for Int. cards)';
        break;
      }
      case 'MX': {
        this.pricingTextLight =
          '3.6% + MXN$ 3';
        break;
      }
      case 'DK': {
        this.pricingTextLight =
          'EEA cards: 1.4% + Kr 1.8<br><hr>UK cards: +1.1%<br>International cards: +1.5%';
        break;
      }
      case 'SE': {
        this.pricingTextLight =
          'EEA cards: 1.5% + Kr 1.8<br><hr>UK cards: +1.1%<br>International cards: +1.5%';
        break;
      }
      case 'NO': {
        this.pricingTextLight =
          '2.4% + Kr 2<br><hr>International cards: +0.5%';
        break;
      }
      case 'CH': {
        this.pricingTextLight =
          '2.9% + CHF 0.30';
        break;
      }
      case 'US': {
        this.pricingTextLight = '2.9% + $0.30<br><hr>International cards: +1%';
        break;
      }
      case 'CA': {
        this.pricingTextLight =
          '2.9% + $0.30<br><hr>International cards: +0.6%';
        break;
      }
      case 'NZ': {
        this.pricingTextLight = '2.9% + $0.30';
        break;
      }
      case 'HK': {
        this.pricingTextLight = '3.4% + $2.35';
        break;
      }
      case 'GB': {
        this.pricingTextLight =
          'UK Cards: 1.5% + £0.20<br><hr>EEA cards: +1.1%<br>International cards: +1.5%';
        break;
      }
      case 'JP': {
        this.pricingTextLight = '3.6%';
        break;
      }
      case 'SG': {
        this.pricingTextLight = '3.4% + $0.50';
        break;
      }
      case 'IE': {
        this.pricingTextLight =
          'EEA cards: 1.5% + €0.25<br><hr>UK cards: +1%<br>International cards: +1.75% - excl VAT';
        break;
      }
      default: {
        this.pricingTextLight =
          'EEA cards: 1.5% + €0.25<br><hr>UK cards: +1%<br>International cards: +1.75%';
        break;
      }
    }
  }

  checkPayoutsEnabled(stripeAccountId: string): Promise<void> {
    return new Promise((resolve, reject) => {

      this._http.get(environment.firebase.clouldFunctionHost + '/checkPayoutsEnabled?stripeAccountId=' + stripeAccountId, this.requestOptions())
        .subscribe((response: any) => {

          if (response != null && response._body) {

            const jsonResponse: any = JSON.parse(response._body);
            const payoutsEnabled = jsonResponse.payoutsEnabled;
            const chargesEnabled = jsonResponse.chargesEnabled;
            const capabilities = jsonResponse.capabilities;
            this.verification = jsonResponse.verification;

            this.settings.payoutsEnabled = payoutsEnabled;
            this.settings.chargesEnabled = chargesEnabled;
            this.settings.capabilities = capabilities;
            this.settings.verification = this.verification;


            resolve();
            //  });

          }
          // return response;
        });
    });
  }


  getCountry(country: string) {
    switch (country) {
      case 'AU': {
        return 'Australia';
      }
      case 'GB': {
        return 'UK';
      }
      case 'US': {
        return 'United States';
      }
      case 'NZ': {
        return 'New Zealand';
      }
      case 'JP': {
        return 'Japan';
      }
      case 'CA': {
        return 'Canada';
      }
      case 'AT': {
        return 'Austria';
      }
      case 'BE': {
        return 'Belgium';
      }
      case 'EE': {
        return 'Estonia';
      }
      case 'FI': {
        return 'Finland,';
      }
      case 'FR': {
        return 'France';
      }
      case 'DE': {
        return 'Germany,';
      }
      case 'DK': {
        return 'Denmark';
      }
      case 'GR': {
        return 'Greece';
      }
      case 'IE': {
        return 'Ireland';
      }
      case 'IT': {
        return 'Italy';
      }
      case 'LV': {
        return 'Latvia';
      }
      case 'LT': {
        return 'Lithuania';
      }
      case 'LU': {
        return 'Luxembourg';
      }
      case 'MX': {
        return 'Mexico';
      }
      case 'NL': {
        return 'Netherlands';
      }
      case 'PT': {
        return 'Portugal';
      }
      case 'SK': {
        return 'Slovakia';
      }
      case 'SI': {
        return 'Slovenia';
      }
      case 'ES': {
        return 'Spain';
      }
      case 'SG': {
        return 'Singapore';
      }
      case 'HK': {
        return 'Hong Kong';
      }
      case 'NO': {
        return 'Norway';
      }
      case 'CH': {
        return 'Switzerland';
      }
      case 'SE': {
        return 'Sweden';
      }
    }
    this.setCurrency();
  }



  updateSettings(stripeAccountId, publicKey, registryName) {

    this._registryService.sendFbTrackEvent('Stripe connected');
    this._analyticsService.trackEvent('stripeConnected', {
      registryUrl: 'https://www.hitchd.com/' + registryName
    });

    this._analyticsService.update(
      {
        stripeConnected: true,
        isLive: this.registry.isLive,
        stripePayoutsEnabled: this.settings.payoutsEnabled,
        stripeAccountId: this.settings.stripeAccountId,
        registryUrl: 'https://www.hitchd.com/' + this.registry.registryName
      }
    );

    const accountId = stripeAccountId;
    this.settings.stripeAccountId = accountId;
    this.settings.stripePublicKey = publicKey;
    return this._registryFirebaseService.saveSettings(this.settings);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  sendAdwordConversion() {

    const gtag = window['gtag'];
    if (!gtag) {
      return;
    }

    gtag('event', 'conversion', {
      'send_to': 'AW-784025651/A1_qCJKMrKABELOQ7fUC',
      'signup': true,
      'published': true
    });
  }

  onChangeDefaultGiftPrice() {
    this.defaultGiftPriceChanged = true;
  }

  onCheckledHasPassword(checked: boolean) {
    this.registry.hasPassword = checked;
    if (!checked) {
      this.registry.password = '';
    }


  }

  saveRegistry(firstLaunch: boolean = false) {


    this.firstLaunchSaving = firstLaunch;
    if (this.registry.isLive === undefined) {
      this.firstLaunchSaving = true;
    }
    this.setRegistryVisibilityStatus();
    if (this.registry && this.registry.paid !== undefined && this.registry.paid === false) {
      this._router.navigateByUrl('/visibility', { replaceUrl: false });
      return;
    }




    if (!this.registry.hasPassword && this.registry.password) {
      this.registry.password = '';
    }


    this._registryFirebaseService.saveRegistry(this.registry).then(() => {
      if (this.firstLaunchSaving) {

        this._analyticsService.trackEvent('Registry Published'
          , { currency: this.registry.currency, country: this.registry.coupleFeePercent });

        if (this.registry.hasCustomPaymentMethods) {
          this._router.navigateByUrl('/registry/launched', { replaceUrl: true });
        } else {
          this._router.navigateByUrl('/registry/stripe-connected', { replaceUrl: true });
        }


      }
    });
    this._router.navigateByUrl('/registry');


  }

  updateRegistryVisibility(isLive: boolean) {

    if (this.registry.isLive === undefined) {
      this.firstLaunchSaving = true;
    }
    this.registry.isLive = isLive;
    this._registryFirebaseService.saveRegistry(this.registry);
    this.settingsProcessing = false;

    if (this.registry.isLive) {
      this._analyticsService.trackEvent('Registry Published'
        , { currency: this.registry.currency, country: this.registry.coupleFeePercent });

      this._router.navigateByUrl('/registry/stripe-connected', { replaceUrl: true });
    }
    if (!this.registry.isLive) {
      this._analyticsService.trackEvent('Registry Unpublished'
        , { currency: this.registry.currency, country: this.registry.coupleFeePercent });
    }

  }
  updateRegistryLiveStatus(isLive: boolean) {

    if ((this.currency && this.country) && (this.registry.country !== this.country || this.registry.currency !== this.currency)) {
      this.registry.currency = this.currency;
      this.registry.country = this.country;
      this._registryFirebaseService.saveRegistry(this.registry);
    }

    if ((!this.settings || !this.settings.stripeSetupLink || !this.settings.stripeAccountId)) {
      this._analyticsService.trackEvent('Start Stripe Setup'
        , { currency: this.registry.currency, country: this.registry.coupleFeePercent });

      this.setupStripe(null).then(() => {

      });
    }
    else if (this.settings.stripeSetupLink && !(this.settings.chargesEnabled && this.settings.payoutsEnabled)) {
      this._analyticsService.trackEvent('Continue Stripe Setup'
        , { currency: this.registry.currency, country: this.registry.coupleFeePercent });
      this.setupStripe(this.settings.stripeAccountId).then(() => {

      });
    }
    else {
      this.registry.isLive = isLive;
      this._registryFirebaseService.saveRegistry(this.registry);
      this.settingsProcessing = false;

      if (this.registry.isLive) {
        this._analyticsService.trackEvent('Registry Published'
          , { currency: this.registry.currency, country: this.registry.coupleFeePercent });

        this._router.navigateByUrl('/registry/stripe-connected', { replaceUrl: true });
      }
      if (!this.registry.isLive) {
        this._analyticsService.trackEvent('Registry Unpublished'
          , { currency: this.registry.currency, country: this.registry.coupleFeePercent });
      }
    }


  }

  refreshStripeSetupLinks(stripeAccountId): Promise<string> {


    return new Promise((resolve, reject) => {

      this._http.get(environment.firebase.clouldFunctionHost + '/refreshStripeLinks?stripeAccountId=' + stripeAccountId, this.requestOptions())
        .subscribe((response: any) => {

          if (response != null && response._body) {
            const jsonResponse: any = JSON.parse(response._body);
          }
        });
    });
  }

  setupStripe(existingStripeAccountId, skipRedirect = false): Promise<any> {
    this.linkStripeError = false;
    const country = this.registry.country;
    const currency = this.registry.currency;
    const registryName = this.registry.registryName;
    const email = encodeURI(this.user.email.replace(/[\n\t\r]/g, ''));
    //
    //   + 'country=' + country
    //   + '&currency=' + currency
    //   + '&registryName=' + registryName
    //   + '&email=' + email.trim()

    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();

    return this._http
      .post(environment.firebase.clouldFunctionHost + '/stripeOnboard', {
        country: country,
        currency: currency,
        registryName: registryName,
        email: email,
        rid: this.registry.id,
        tid: this.token,
        existingStripeAccountId: existingStripeAccountId
      })
      .toPromise()
      .then((response: any) => {
        const stripeResponse: any = response.json();

        if (!skipRedirect) {
          location.href = stripeResponse.url;
        }

      })
      .catch((e: any) => {
        const error = JSON.parse(e._body);
        if (error.code === 'account_already_exists') {
          this.dupeStripeAccount = true;
          this.stripeProcessing = false;
        }
        else {
          throw e;
        }
      });

  }


  copy() {
    this.setClipboardText('www.hitchd.com/' + this.registry.registryName);
  }

  setClipboardText(text) {
    const id = 'mycustom-clipboard-textarea-hidden-id';
    let existsTextarea: any = document.getElementById(id);

    if (!existsTextarea) {
      const textarea: any = document.createElement('textarea');
      textarea.id = id;
      // Place in top-left corner of screen regardless of scroll position.
      textarea.style.position = 'fixed';
      textarea.style.top = 0;
      textarea.style.left = '-10px';

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textarea.style.width = '1px';
      textarea.style.height = '1px';

      // We don't need padding, reducing the size if it does flash render.
      textarea.style.padding = 0;

      // Clean up any borders.
      textarea.style.border = 'none';
      textarea.style.outline = 'none';
      textarea.style.boxShadow = 'none';

      // Avoid flash of white box if rendered for any reason.
      textarea.style.background = 'transparent';
      document.querySelector('body').appendChild(textarea);

      existsTextarea = document.getElementById(id);
    } else {
    }

    existsTextarea.value = text;
    existsTextarea.select();

    try {
      const status = document.execCommand('copy');

      if (!status) {
      } else {
        this.coppied = true;

        setTimeout(() => {
          this.coppied = false;
        }, 2 * 1000);
      }
    } catch (err) { }
  }

  private handleStripeParams(params: any) {
    if (params['fromStripe'] === '1') {
      this.fromStripe = true;
      this.paid = false;
    } else {
      this.fromStripe = false;
      if (params['currency']) {
        this.paid = true;
      }
    }
  }

  private processConversion(userId: string) {
    this.conversionProcessed = true;
    const conversionSent = localStorage.getItem('sent_conversion');
    this.conversionAlreadySent = conversionSent === 'true';
    this.conversionCompleted = true;
    this.currency = this.queryParams['currency'];
    this.order_id = userId;
    this.total = this.queryParams['value'];

    if (!conversionSent) {
      this._analyticsService.trackGoogleAdsAndPinterestEvent('Order Completed', {
        order_id: userId,
        currency: this.queryParams['currency'],
        value: this.queryParams['value'],
        total: this.queryParams['value'],
        subtotal: this.queryParams['value'],
        revenue: this.queryParams['value'],
        shipping: 0,
        tax: 0,
        products: [
          {
            product_id: this.queryParams['currency'] + this.queryParams['value'],
            sku: this.queryParams['currency'] + this.queryParams['value'],
            name: 'Hitchd Honeymoon Registry',
            price: this.queryParams['value'],
            quantity: 1,
            category: 'Online',
            url: 'https://www.hitchd.com'
          }
        ]
      });
      localStorage.setItem('sent_conversion', 'true');
      this.fromStripe = false;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/account-payment/account-payment.component.ts